import { render } from "./PrivacyPolicyView.vue?vue&type=template&id=5b171209&scoped=true&ts=true"
import script from "./PrivacyPolicyView.vue?vue&type=script&lang=ts"
export * from "./PrivacyPolicyView.vue?vue&type=script&lang=ts"

import "./PrivacyPolicyView.vue?vue&type=style&index=0&id=5b171209&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b171209"]])

export default __exports__